import {styled} from "@mui/material/styles";
import {Box} from "@mui/material";

export const AppBox = styled(Box)`
  display: flex;
  width: 100%;
`
